<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
                 style="background-image: url('/images/page-title-bg.jpg')">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="page-title-item text-center">
                            <h3 class="title">Register</h3>
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item">
                                        <router-link to="/">Home</router-link>
                                    </li>
                                    <li class="breadcrumb-item active" aria-current="page">Register</li>
                                </ol>
                            </nav>
                        </div> <!-- page title item -->
                    </div>
                </div> <!-- row -->
            </div> <!-- row -->
            <div class="page-title-shape">
                <img src="/images/banner-shape.png" alt="shape">
            </div> <!-- page title shape -->
        </section>
        <section class="contact-touch-area pt-85 pb-90">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-lg-9">
                        <div class="contact-touch-part">
                            <div class="row">
                                <div class="col-lg-12">
                                    <div class="secton-title text-center">
                                        <h5 class="title">Create an account</h5>
                                        <p>Join other 2000+ users!</p>
                                    </div>
                                </div>
                            </div>
                            <form id="contact-form" @submit.prevent="register" autocomplete="off">
                                <div class="row">
                                    <div class="col-lg-12 text-center">
                                        <label>Select account type</label>
                                        <div class="input-box mt-2">
                                            <RadioToggleButtons
                                                    v-model='form.type'
                                                    :values='values'
                                                    color='#fb803a'
                                                    textColor='#000'
                                                    selectedTextColor='#fff'
                                            />
                                        </div>
                                        <small style="color: red" v-if="error && errors.type">{{ errors.type[0]
                                            }}</small>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.name" name="name" type="text" placeholder="Your name">
                                            <small style="color: red" v-if="error && errors.name">{{ errors.name[0]
                                                }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.email" name="email" type="email"
                                                   placeholder="Your Email">
                                            <small style="color: red" v-if="error && errors.email">{{ errors.email[0]
                                                }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.phone" name="phone" type="tel"
                                                   placeholder="Your Phone Number">
                                            <small style="color: red" v-if="error && errors.phone">{{ errors.phone[0]
                                                }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <VueGooglePlaces
                                                    :api-key="key"
                                                    types="establishment"
                                                    country="ke"
                                                    @placechanged="onPlaceChanged"
                                                    @noresult="onNoResult">
                                                <input v-model="form.loc" name="location" type="text"
                                                       placeholder="Your Location">
                                            </VueGooglePlaces>
                                            <small style="color: red" v-if="error && errors.location_name">{{
                                                errors.location_name[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6" v-if="form.type == 'rider'">
                                        <div class="input-box mt-35">
                                            <input v-model="form.id_number" name="id_no" type="text"
                                                   placeholder="ID Number">
                                            <small style="color: red" v-if="error && errors.id_number">{{
                                                errors.id_number[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6" v-if="form.type == 'rider'">
                                        <div class="input-box mt-35">
                                            <VueGooglePlaces
                                                    :api-key="key"
                                                    types="establishment"
                                                    country="ke"
                                                    @placechanged="operationArea"
                                                    @noresult="onNoResult">
                                                <input v-model="form.area" name="area_of_operation" type="text"
                                                       placeholder="Area of operation">
                                            </VueGooglePlaces>
                                            <small style="color: red" v-if="error && errors.operation_area">{{
                                                errors.operation_area[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6" v-if="form.type == 'rider'">
                                        <div class="input-box mt-35">
                                            <select v-model="form.vehicle_type" style="width: 100%; background: #f5f5f5;
                                             border: 1px solid #dcd9d9; height: 45px; padding-left: 30px; font-size: 12px;
                                                color: #999;">
                                                <option value="" selected>Vehicle type</option>
                                                <option value="Bicycle">Bicycle</option>
                                                <option value="Motorcycle">Motorcycle</option>
                                                <option value="Tuk-tuk">Tuk-tuk</option>
                                                <option value="Pickup">Pickup</option>
                                                <option value="Van">Van</option>
                                            </select>
                                            <small style="color: red" v-if="error && errors.vehicle_type">{{
                                                errors.vehicle_type[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6" v-if="form.type == 'wholesaler' || form.type == 'retailer'">
                                        <div class="input-box mt-35">
                                            <input v-model="form.shop_name" name="shop_name" type="text"
                                                   placeholder="Shop name">
                                            <small style="color: red" v-if="error && errors.shop_name">{{
                                                errors.shop_name[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.password" name="password" type="password"
                                                   placeholder="Password">
                                            <small style="color: red" v-if="error && errors.password">{{
                                                errors.password[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <div class="input-box mt-35">
                                            <input v-model="form.password_confirmation" name="password_confirmation"
                                                   type="password" placeholder="Confirm Password">
                                            <small style="color: red" v-if="error && errors.password_confirmation">{{
                                                errors.password_confirmation[0] }}</small>
                                        </div>
                                    </div>
                                    <div class="col-lg-12">
                                        <div class="input-box mt-35 text-center">
                                            <button type="submit">Register</button>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <div class="vld-parent">
            <loading :active.sync="isLoading"
                     :can-cancel="true"
                     :is-full-page="fullPage"></loading>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    import "vue-loading-overlay/dist/vue-loading.css";

    export default {
        name: "Register",
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                error: false,
                errors: {},
                key: "AIzaSyD_q2KJ5vODTs1xOXxn6j8gjX5ZMr-2YzY",
                values: [
                    {label: 'Customer', value: 'customer'},
                    {label: 'Wholesaler', value: 'wholesaler'},
                    {label: 'Retailer', value: 'retailer'},
                    {label: 'Rider', value: 'rider'},
                ],
                place: [],
                operation: [],
                form: {
                    name: '',
                    email: '',
                    phone: '',
                    type: '',
                    county: '',
                    longitude: '',
                    latitude: '',
                    address: '',
                    location_name: '',
                    operation_area: '',
                    password: '',
                    password_confirmation: '',
                    shop_name: '',
                    id_number: '',
                    vehicle_type: '',
                    area: '',
                    loc: ''
                }
            }
        },
        methods: {
            register() {
                this.isLoading = true;
                this.$auth.register({
                    data: {
                        name: this.form.name,
                        email: this.form.email,
                        phone: this.form.phone,
                        type: this.form.type,
                        county: this.form.county,
                        longitude: this.form.longitude,
                        latitude: this.form.latitude,
                        address: this.form.address,
                        location_name: this.form.location_name,
                        operation_area: this.form.operation_area,
                        password: this.form.password,
                        password_confirmation: this.form.password_confirmation,
                        shop_name: this.form.shop_name,
                        id_number: this.form.id_number,
                        vehicle_type: this.form.vehicle_type
                    },
                    success: function () {
                        this.isLoading = false;
                        this.$swal(
                            {
                                title: 'Hurray',
                                text: "Your account was created successfully! Click the verification link sent to your email to verify your account",
                                icon: 'success',
                                confirmButtonColor: 'green',
                                confirmButtonText: 'Log In!'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push('/login')
                                }
                            }
                        );
                        this.form = {
                            name: '',
                            email: '',
                            phone: '',
                            type: '',
                            county: '',
                            longitude: '',
                            latitude: '',
                            address: '',
                            location_name: '',
                            operation_area: '',
                            password: '',
                            password_confirmation: '',
                            shop_name: '',
                            id_number: '',
                            vehicle_type: '',
                            area: '',
                            loc: ''
                        }
                    },
                    error: function (resp) {
                        this.isLoading = false;
                        this.error = true;
                        this.errors = resp.response.data.errors;
                    },
                    redirect: null
                });
            },
            onNoResult() {

            },
            onPlaceChanged(e) {
                this.place = e;
                this.form.county = this.place.administrative_area_level_1;
                this.form.longitude = this.place.longitude;
                this.form.latitude = this.place.latitude;
                this.form.address = this.place.formatted_address;
                this.form.location_name = this.place.name;
            },
            operationArea(e) {
                this.operation = e;
                this.form.operation_area = this.operation.formatted_address + "," + this.operation.name + "," +
                    this.operation.administrative_area_level_1;
            }

        }
    }
</script>

<style scoped>

</style>